// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offeringModal .row {
  margin-bottom: 45px;
}

.offeringModal .row.buttons {
  height: 45px;
  margin-bottom: 0px;
}

.offeringModal .row:last-child {
  margin-bottom: 0px;
}

.offeringModal .row.searchForm .col-md-2 {
  padding: 0px;
}

.offeringModal .row.results {
  background-color: #fff;
  margin: 0px 0px 15px;
  padding: 15px;
}

.offeringModal .row.results h3 {
  margin: 0px 0px 45px;
}

.offeringModal .row.results ul {
  padding: 0px;
}

.offeringModal .row.results ul li {
  background-color: #f0f0f0;
  list-style: none;
  padding: 15px 15px 15px 40px;
}

.offeringModal .row.results ul li {
  list-style: none;
}

.number-students-selected {
  font-size: 13px;
  padding-top: 11px;
}

.modal.rosterModal .modal-dialog {
  max-width: 1500px;
  width: 1300px;
}

.rosterModal md-content {
  overflow: hidden;
}

.rosterModal .roster-detail-link {
  display: none;
}

.rosterModal md-tab-content {
  min-height: 400px;
  background-color: #fff;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/offerings/modals.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB","sourcesContent":[".offeringModal .row {\n  margin-bottom: 45px;\n}\n\n.offeringModal .row.buttons {\n  height: 45px;\n  margin-bottom: 0px;\n}\n\n.offeringModal .row:last-child {\n  margin-bottom: 0px;\n}\n\n.offeringModal .row.searchForm .col-md-2 {\n  padding: 0px;\n}\n\n.offeringModal .row.results {\n  background-color: #fff;\n  margin: 0px 0px 15px;\n  padding: 15px;\n}\n\n.offeringModal .row.results h3 {\n  margin: 0px 0px 45px;\n}\n\n.offeringModal .row.results ul {\n  padding: 0px;\n}\n\n.offeringModal .row.results ul li {\n  background-color: #f0f0f0;\n  list-style: none;\n  padding: 15px 15px 15px 40px;\n}\n\n.offeringModal .row.results ul li {\n  list-style: none;\n}\n\n.number-students-selected {\n  font-size: 13px;\n  padding-top: 11px;\n}\n\n.modal.rosterModal .modal-dialog {\n  max-width: 1500px;\n  width: 1300px;\n}\n\n.rosterModal md-content {\n  overflow: hidden;\n}\n\n.rosterModal .roster-detail-link {\n  display: none;\n}\n\n.rosterModal md-tab-content {\n  min-height: 400px;\n  background-color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
